const currentYearElement = document.querySelector<HTMLElement>('[data-current-year]');

if (currentYearElement) {
	currentYearElement.innerHTML = new Date().getFullYear().toString();
}
